import { Image, Stack } from '@chakra-ui/react';
import { useDefaultTokenAvatar } from '@/lib/hooks/useDefaultTokenAvatar';
import { CHAIN_INFO } from '@/lib/config/chain';

type Props = {
  tokenAvatar: string;
  chainAvatar: string;
};

export const TokenAvatar = ({ tokenAvatar, chainAvatar }: Props) => {
  const defaultAvatar = useDefaultTokenAvatar();
  return (
    <Stack w={8} h={8} pos={'relative'} flexShrink={0}>
      <Image
        src={tokenAvatar || defaultAvatar}
        w={8}
        h={8}
        rounded={'full'}
        alt="Token Avatar"
      />
      <Image
        src={chainAvatar || CHAIN_INFO['SOL']?.icon}
        w={3}
        h={3}
        rounded={'full'}
        bottom={'-4px'}
        right={'-4px'}
        pos={'absolute'}
        alt="Chain Avatar"
      />
    </Stack>
  );
};
